import React, { useEffect, useState, useContext, Dispatch, SetStateAction } from 'react';
import { Table, TableCell, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { AppContext } from '../../../../App';
import dayjs from 'dayjs';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import TimeEntry from '../../../atoms/Input/TimeEntry';
import { TableBaseStyle } from '../../../../baseStyle/tableBaseStyle';
import { TableUseStyle, ConanairManagementStyle } from './ConanairManagementStyle';
import { CONNAIR_SET, ColSetLogModel } from './ConanairManagement';

type ConanairManagementBodyProps = {
  rowno: number;
  selectIdx: number;
  conanItem: CONNAIR_SET;
  devCombList: ComboBoxItemType[];
  nameItemCombList: ComboBoxItemType[];
  setSelectIdx: Dispatch<SetStateAction<number>>;
  updateItem: (item: CONNAIR_SET) => void;
};
const ConanairManagementBody: React.FC<ConanairManagementBodyProps> = (props: ConanairManagementBodyProps) => {
  const tableBaseStyle = TableUseStyle();
  const baseClasses = TableBaseStyle();
  const pageStyle = ConanairManagementStyle();
  const editRow: CONNAIR_SET = props.conanItem;
  const { login } = useContext(AppContext);
  const logtimer = new Date(props.conanItem.logStart !== "" ? props.conanItem.logStart : "2023-01-01 00:00:00");

  const logHour = logtimer.getHours().toString();
  const logMin = logtimer.getMinutes().toString();
  const logSec = logtimer.getSeconds().toString();

  //console.debug(["logtimer check", logtimer, logHour, logMin, logSec]);
  /**
   *行選択ハンドラ 
   * @param selectRow 
   */
  const selectRowAction = (selectRow: CONNAIR_SET) => {
    console.debug(['selectRow()', props.rowno]);
    props.setSelectIdx(props.rowno);
  };

  /**
   * item変更通知
   * @param editRow 
   * @param editFlg 
   */
  const ChangeItemDataAction = (editRow: CONNAIR_SET, editFlg: boolean) => {
    if (editFlg) {
      props.updateItem(editRow);
    }
  };

  /**
   * 収集時刻の更新
   */
  const ChangeLogStart = (hour: string, minute: string, sec: string) => {
    let dateTimeNow = new Date;
    let year = dateTimeNow.getFullYear();
    let month = dateTimeNow.getMonth();
    let date = dateTimeNow.getDate();

    let logStartItem = new Date(year, month, date, Number(hour), Number(minute), Number(sec));

    //現在時刻よりも収集時刻を後の時刻に設定
    editRow.logStart = logStartItem > dateTimeNow ?
      dayjs(logStartItem).format('YYYY-MM-DD HH:mm:ss') :
      dayjs(logStartItem.setDate(logStartItem.getDate() + 1)).format('YYYY-MM-DD HH:mm:ss');

    //console.debug(["ChangeLogStart", editRow, dateTimeNow, year, month, date, logStartItem, hour, minute, sec]);
    ChangeItemDataAction(editRow, true);
  }

  //行選択の背景色一時置き
  let lineSelection = '';

  return (
    <>
      <div className={`${lineSelection = tableBaseStyle.bodyRow} ${lineSelection = baseClasses.bodyRow}`}></div>
      <TableRow key={props.rowno + 1}
        hover
        onClick={() => {
          selectRowAction(editRow);
        }}
        selected={props.selectIdx === props.rowno}
        className={lineSelection}
      >
        {/* No */}
        <TableCell className={tableBaseStyle.bodyCellCenter}>{props.rowno}</TableCell>
        {/* 機器番号 */}
        <TableCell className={tableBaseStyle.bodyCellCenter}>
          <ItemComboBox
            itemList={props.devCombList}
            label=""
            value={editRow.DEV_INDEX}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                editRow.DEV_INDEX = parseInt(e.target.value);
                ChangeItemDataAction(editRow, true);
              }
            }}
          />
        </TableCell>
        {/* 機器名称 */}
        <TableCell className={tableBaseStyle.bodyCellCenter}>
          {editRow.devName}
        </TableCell>
        {/* 取付箇所 */}
        <TableCell className={tableBaseStyle.bodyCellCenter}>
          <ItemComboBox
            itemList={props.nameItemCombList}
            label=""
            value={editRow.ITM_NAME_NO}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                editRow.ITM_NAME_NO = parseInt(e.target.value);
                ChangeItemDataAction(editRow, true);
              }
            }}
          />
        </TableCell>
        {/**コナンエアID */}
        <TableCell className={tableBaseStyle.bodyCellCenter} >
          {editRow.CNA_ID}
        </TableCell>
        {/**収集時刻 */}
        {login.IsIoT === true ?
          <TableCell className={tableBaseStyle.bodyCellCenter}
            onClick={(e) => {
              console.debug(["onClick"])
              if (props.conanItem.logStart === "") {
                ChangeLogStart("0", "0", "0");
              }
            }}
          >
            {props.conanItem.logStart !== "" ?
              <div className={pageStyle.flexBox}>
                <TimeEntry
                  value={logHour}
                  maxValue={23}
                  minValue={0}
                  onChange={(val) => {
                    ChangeLogStart(val, logMin, logSec);
                  }}
                  className={tableBaseStyle.logTimeField}
                />
                :
                <TimeEntry
                  value={logMin}
                  maxValue={59}
                  minValue={0}
                  onChange={(val) => {
                    ChangeLogStart(logHour, val, logSec);
                  }}
                  className={tableBaseStyle.logTimeField}
                />
                :
                <TimeEntry
                  value={logSec}
                  maxValue={59}
                  minValue={0}
                  onChange={(val) => {
                    ChangeLogStart(logHour, logMin, val);
                  }}
                  className={tableBaseStyle.logTimeField}
                />
              </div>
              : ''
            }

          </TableCell>
          : null
        }

      </TableRow>
    </>
  );
};

export default ConanairManagementBody;